import React from 'react';
import '../scss/components/section.scss';
import Header from '../components/header/header.jsx';
import Footer from '../components/footer/footer-v1';
import dataFooter from '../assets/fake-data/data-footer';
import Bottom from '../components/bottom';

function TnC(props) {
    return (
        <div className='wrapper-style sv2-tnc-prvcy' id='wrapper'>
            {<Header />}
            <div className='sellagen-fact'>
                <h2 className="sellagen-fact-title"><strong>Terms of Service Agreement</strong></h2>
                <br/>
                <p>This Terms of Service Agreement (“Agreement” or “Terms”) constitutes a legally binding contract between <strong>SELLAGEN Inc.</strong>, a Delaware corporation (“SELLAGEN,” “Nelima,” “we,” “us,” or “our”), and the individual or entity accessing or using SELLAGEN’s products or services (collectively, the “Product” or “Services”) (“Customer,” “you,” or “your”).</p>
                <br/>
                <p>By accessing, registering for, or using the Product, you acknowledge that you have read, understood, and agree to be bound by all terms and conditions set forth in this Agreement. If you do not agree to all the terms herein, you must not use or access the Product.</p>
                <br/><br/><br/>
                
                <h3 className='fs-20 text-color-4'>1. Agreement Composition</h3>
                <br/>
                <p>This Agreement is composed of the following components, all of which collectively govern your use of the Product:</p>
                <br/>
                <p>&emsp;• This Terms of Service document (“Terms”)</p>
                <p>&emsp;• Any Order Form, purchase agreement, or subscription agreement executed by you or your organization (“Order Form”)</p>
                <br/>
                <p>In the event of any inconsistency between these Terms and any Order Form, the terms set forth in the Order Form shall prevail to the extent of such conflict.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>2. Product Description</h3>
                <br/>
                <p><strong>Nelima</strong> is an agentic AI personal assistant designed to perform complex, multi-step tasks across your workflows from a single prompt. Nelima can run email campaigns, pull data from the web, create or edit files, query private databases, chain actions between tools, automate scheduling, and execute thousands of repetitive tasks without code, visual workflow builders, or constant oversight.</p>
                <br/>
                <p>Nelima combines memory, scheduling, web browsing, file access (“agentic storage”), and integrations with browsers, APIs, databases, and IoT devices. She can also learn new tasks from you and reuse them for your future workflows or, if you choose, for the wider Nelima community.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>3. Subscription and Access</h3>
                <br/>
                <p>Access to the Product is provided on a subscription basis, with subscription periods (“Subscription Period”) defined in the applicable Order Form or purchase confirmation. Unless otherwise specified, subscriptions automatically renew for successive periods until terminated in accordance with this Agreement. You are responsible for maintaining the confidentiality of your login credentials and all activities conducted through your account.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>4. Fees and Payment Terms</h3>
                <br/>
                <p>Customer agrees to pay all fees, charges, and applicable taxes associated with their use of the Product as set forth in the Order Form or on SELLAGEN’s published pricing page at the time of purchase.</p>
                <br/>
                <p>SELLAGEN reserves the right to modify pricing or introduce new fees with at least thirty (30) days’ prior notice via email or through in-Product notification. Any such changes shall become effective at the start of the subsequent Subscription Period.</p>
                <br/>
                <p>Payments shall be made according to the payment terms specified in the Order Form. Failure to pay may result in suspension or termination of access.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>5. Account Registration and Responsibilities</h3>
                <br/>
                <p>You agree to provide true, accurate, current, and complete information when registering for or using the Product. You are solely responsible for maintaining the security and confidentiality of your account credentials and for all activities that occur under your account.</p>
                <br/>
                <p>By providing your phone number or contact details, you explicitly consent to receive notifications from Nelima, including scheduling reminders or action confirmations. Standard message and data rates may apply. You may opt out at any time through your settings or by contacting us directly.</p>
                <br/>
                <p>You agree to immediately notify SELLAGEN of any unauthorized use or suspected breach of your account. SELLAGEN shall not be liable for any loss or damage arising from your failure to comply with these obligations.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>6. Permitted and Prohibited Uses</h3>
                <br/>
                <p>You agree to use the Product strictly in compliance with all applicable laws, rules, and regulations. You shall not use the Product to:</p>
                <br/>
                <p>&emsp;• Violate intellectual property or other rights of third parties</p>
                <br/>
                <p>&emsp;• Upload or transmit viruses, malware, or harmful code</p>
                <br/>
                <p>&emsp;• Interfere with or disrupt the integrity or performance of the Product or its data</p>
                <br/>
                <p>&emsp;• Attempt to gain unauthorized access to the Product or related systems</p>
                <br/>
                <p>&emsp;• Engage in fraudulent, abusive, or unlawful activities</p>
                <br/>
                <p>SELLAGEN reserves the right to suspend or terminate access for violations of this Section.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>7. Intellectual Property Rights</h3>
                <br/>
                <p>All rights, title, and interest in and to the Product, including but not limited to software, technology, documentation, trademarks, and related intellectual property, remain exclusively with SELLAGEN or its licensors. Nothing in this Agreement transfers ownership of any intellectual property to you. Your use of the Product is limited to a non-exclusive, non-transferable, revocable license to access and use the Product in accordance with this Agreement.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>8. User-Contributed Actions: Public and Private</h3>
                <br/>
                <h3 className='fs-16 fw-6 text-color-4'>8.1 Public Actions</h3>
                <br/>
                <p>As a User, you may contribute custom actions, workflows, or prompts to Nelima’s ecosystem (“Public Actions”). By submitting a Public Action, you grant SELLAGEN a worldwide, royalty-free, perpetual license to use, modify, display, and make available that Public Action for use by other Users.</p>
                <br/>
                <p>You represent and warrant that you have all necessary rights to contribute any Public Action and that your contributions do not infringe any third-party rights. SELLAGEN may review, curate, or remove Public Actions that violate these Terms or applicable law.</p>
                <br/><br/>
                <h3 className='fs-16 fw-6 text-color-4'>8.2 Private Actions</h3>
                <br/>
                <p>You may also create and store custom actions that are private to your account (“Private Actions”). Private Actions are for your individual or organizational use only and will not be shared with other Users unless you explicitly choose to make them Public. SELLAGEN will handle your Private Actions in accordance with our Privacy Policy.</p>
                <br/>
                <p>You retain ownership of all Private Actions you create, subject to the limited license you grant SELLAGEN to store, process, and use them solely for providing the Services.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}


                <h3 className='fs-20 text-color-4'>9. Customer Data and Privacy</h3>
                <br/>
                <p>You retain ownership of any data, files, or instructions you provide or generate using the Product (“Customer Data”). SELLAGEN will use Customer Data only to deliver and improve the Product, as described in our Privacy Policy, which is incorporated by reference herein.</p>
                <br/>
                <p>By connecting third-party services, you authorize SELLAGEN to access data from those services as required to fulfill your requests. You are responsible for ensuring you have all necessary rights to upload or use any data within the Product.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>10. Termination and Suspension</h3>
                <br/>
                <p>Either party may terminate this Agreement or your access to the Product in accordance with the terms specified in the Order Form or by providing written notice. SELLAGEN may suspend or terminate your access immediately if you materially breach any provision of this Agreement, including nonpayment or prohibited use. Upon termination, all licenses granted to you shall immediately cease, and you must discontinue use of the Product.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>11. Disclaimers and Limitation of Liability</h3>
                <br/>
                <p>THE PRODUCT IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. SELLAGEN DOES NOT WARRANT THAT THE PRODUCT WILL BE UNINTERRUPTED OR ERROR-FREE.</p>
                <br/>
                <p>IN NO EVENT SHALL SELLAGEN’S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT EXCEED THE FEES PAID BY YOU TO SELLAGEN DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE CLAIM.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>12. Governing Law and Dispute Resolution</h3>
                <br/>
                <p>This Agreement shall be governed by and construed in accordance with the laws of the State of Delaware, without regard to conflict of law principles. Any dispute arising out of or relating to this Agreement shall be resolved by binding arbitration administered by the American Arbitration Association in Wilmington, Delaware, under its Commercial Arbitration Rules, unless otherwise required by applicable law.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>13. Amendments</h3>
                <br/>
                <p>SELLAGEN reserves the right to modify or update these Terms at any time by providing at least thirty (30) days’ prior notice via email or Product notification. Your continued use of the Product after the effective date of any such changes constitutes acceptance of the revised Terms.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>14. Contact Information</h3>
                <br/>
                <p>For questions regarding this Agreement, please contact:
                    <br/>
                    <strong>support@sellagen.com</strong>
                    <br/>
                    SELLAGEN Inc.
                </p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

            </div>
            {<Footer data={dataFooter}/>}
            {<Bottom classection='widget-social-footer'/>}
        </div>
    );
}

export default TnC